const gpaOptions = [
  { text: 'GPA Cumulative', value: 'cumulativeGpa' },
  { text: 'GPA Cumulative Converted', value: 'cumulativeGpaConverted' },
  { text: 'GPA Weighted', value: 'weightedGpa' },
  { text: 'GPA Weighted Converted', value: 'weightedGpaConverted' },
];

const gpaOptionsNew = [
  { text: 'GPA Cumulative', value: 'cumulativeGpa' },
  { text: 'GPA Weighted', value: 'weightedGpa' },
];

const satOptions = [
  { text: 'Total', value: 'satTotal' },
  { text: 'Math', value: 'satMath' },
  { text: 'Reading Writing', value: 'satReadingWriting' },
];

const actOptions = [
  { text: 'Composite', value: 'actComposite' },
  { text: 'English', value: 'actEnglish' },
  { text: 'Math', value: 'actMath' },
  { text: 'Reading', value: 'actReading' },
  { text: 'Science', value: 'actScience' },
];

const testScoresByOption = {
  satTotal: 'SAT Combined',
  satMath: 'SAT Math',
  satReadingWriting: 'SAT Critical Reading',
  actComposite: 'ACT Combined',
  actEnglish: 'ACT English',
  actMath: 'ACT Math',
  actReading: 'ACT Reading',
  actScience: 'ACT Science',
};

const optionsByName = {
  GPA: gpaOptions,
  GPA_NEW: gpaOptionsNew,
  SAT: satOptions,
  ACT: actOptions,
};

const scaleByType = {
  GPA: { low: 0, high: 4 },
  SAT: { low: 400, high: 1600 },
  SATOther: { low: 200, high: 800 },
  ACT: { low: 0, high: 36 },
};

const schoolAcceptedTestScoreKeys = [
  'act.actComposite',
  'act.actEnglish',
  'act.actMath',
  'act.actReading',
  'act.actScience',
  'act.actWriting',
  'sat.satTotal',
  'sat.satMath',
  'sat.satReadingWriting',
  'gpa',
  'gpaConverted',
  'weightedGpa',
  'weightedGpaConverted',
];

export { testScoresByOption, optionsByName, scaleByType, schoolAcceptedTestScoreKeys };
